import axios from 'axios';
import React, { Component } from 'react'
import { snowmindsConfig } from '../../configuration';
import UmbracoPageGrid from '../umbracoGrid/UmbracoPageGrid';
import UmbracoReusableGrid from '../umbracoGrid/UmbracoReusableGrid';

class LocationPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            banner: {},
            intro:{}
        }
    }
    componentDidMount() {
        this.fetchCountry();
    }
    fetchCountry = () => {

        let snowminds = snowmindsConfig.getSnowMindsConfiguration();
        const url = snowminds.getdestination.locationApi;
        const pageId = this.props.contentid;
        const culture = document.getElementById("hdLanguage").value;
        let params = { pageId: pageId, culture: culture };
        axios.get(url, { params: params }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(res => {

                //(res + `country detail page`)

                if (res.data) {
                    this.setState(res.data);
                    document.title =res.data.intro.title;
                    if (document.getElementsByClassName("loader-wrapper")[0])
                        document.getElementsByClassName("loader-wrapper")[0].style.display = "none";
                }
            })
            .catch(err => {
                //(err)
            });
    }
    render() {
        const { banner, intro, name } = this.state;
        const { heading, image, shortTitle } = banner || {};
        return (
            <section className="static-page-wrapper">
                <div className="static-width">
                    <div className="static-page">

                        {/* <!-- banner --> */}
                        <div className="static-banner" style={{ backgroundImage: `url(${image})` }}>
                            <div className="static-container">
                                <div className="banner-cta-content">


                                    <div className="caption" style={{ maxWidth: `100%` }}>
                                        <h1 style={{ textAlign: `center` }}>{heading}</h1>
                                    </div>
                                    <div className="caption" style={{ maxWidth: `100%` }}>
                                        <h3 style={{ textAlign: `center`, color: `white`, display: `block` }}>{shortTitle}</h3>
                                    </div>


                                </div>

                            </div>
                        </div>

                        <UmbracoPageGrid pageId={this.props.contentid}></UmbracoPageGrid>
                        <UmbracoReusableGrid pageId={this.props.contentid}></UmbracoReusableGrid>
                    </div>
                </div>
            </section>
        )
    }
}

export default LocationPage
